import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from '@tanstack/react-router'

import { AppProviders } from '@/app/providers/app-providers'
import { router } from '@/app/router'
import { InitialSessionSplash } from '@/features/auth/components/initial-session-splash'
import '@/styles/globals.css'

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Unable to mount app: #root element was not found.')
}

createRoot(rootElement).render(
  <StrictMode>
    <AppProviders>
      <InitialSessionSplash router={router} />
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
)
